unit View.Grade_Descricoes.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewGrade_DescricoesList = class(TForm)
    btNew: TButton;
    Grade_DescricoesDataset: TXDataWebDataSet;
    Grade_DescricoesDatasetid: TIntegerField;
    Grade_DescricoesDatasetaliado_id: TIntegerField;
    Grade_DescricoesDatasetdata_base_id: TIntegerField;
    Grade_DescricoesDatasetnome: TStringField;
    Grade_DescricoesDatasettipo: TIntegerField;
    Grade_DescricoesDatasetcodigo_interno: TIntegerField;
    Grade_DescricoesDatasetexcluido: TBooleanField;
    Grade_DescricoesDatasetinclusao: TDateTimeField;
    Grade_DescricoesDatasetalteracao: TDateTimeField;
    Grade_DescricoesDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewGrade_DescricoesList: TFViewGrade_DescricoesList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGrade_DescricoesList }

procedure TFViewGrade_DescricoesList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewGrade_DescricoesList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGrade_DescricoesList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewGrade_DescricoesList, AElementID, Result, @AfterCreate);
end;

procedure TFViewGrade_DescricoesList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewGrade_DescricoesList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewGrade_DescricoesList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Grade_DescricoesDataset.Connection.Model.DefaultSchema.FindEntityType(Grade_DescricoesDataset.EntitySetName),
      Grade_DescricoesDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewGrade_DescricoesList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('grade_descricoes', 'active');
  TUtils.SetValorDicionarioClasses('produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_produtos', 'active');
  TUtils.SetValorDicionarioClasses('grades_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_grades', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Grade_DescricoesDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewGrade_DescricoesList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.grade_descricoes.list.pagination.info');
  btNew := TButton.Create('view.grade_descricoes.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.grade_descricoes.list.table');
  cbPageSize := TComboBox.Create('view.grade_descricoes.list.cbPageSize');
  edSearch := TEdit.Create('view.grade_descricoes.list.search');
  lcPaginator := TListControl.Create('view.grade_descricoes.list.pagination');
  Grade_DescricoesDataset := TXDataWebDataSet.Create(Self);
  Grade_DescricoesDatasetid := TIntegerField.Create(Self);
  Grade_DescricoesDatasetaliado_id := TIntegerField.Create(Self);
  Grade_DescricoesDatasetdata_base_id := TIntegerField.Create(Self);
  Grade_DescricoesDatasetnome := TStringField.Create(Self);
  Grade_DescricoesDatasettipo := TIntegerField.Create(Self);
  Grade_DescricoesDatasetcodigo_interno := TIntegerField.Create(Self);
  Grade_DescricoesDatasetexcluido := TBooleanField.Create(Self);
  Grade_DescricoesDatasetinclusao := TDateTimeField.Create(Self);
  Grade_DescricoesDatasetalteracao := TDateTimeField.Create(Self);
  Grade_DescricoesDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Grade_DescricoesDataset.BeforeLoadDFMValues;
  Grade_DescricoesDatasetid.BeforeLoadDFMValues;
  Grade_DescricoesDatasetaliado_id.BeforeLoadDFMValues;
  Grade_DescricoesDatasetdata_base_id.BeforeLoadDFMValues;
  Grade_DescricoesDatasetnome.BeforeLoadDFMValues;
  Grade_DescricoesDatasettipo.BeforeLoadDFMValues;
  Grade_DescricoesDatasetcodigo_interno.BeforeLoadDFMValues;
  Grade_DescricoesDatasetexcluido.BeforeLoadDFMValues;
  Grade_DescricoesDatasetinclusao.BeforeLoadDFMValues;
  Grade_DescricoesDatasetalteracao.BeforeLoadDFMValues;
  Grade_DescricoesDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewGrade_DescricoesList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tipo';
      Title := 'tipo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Grade_DescricoesDataset.SetParentComponent(Self);
    Grade_DescricoesDataset.Name := 'Grade_DescricoesDataset';
    Grade_DescricoesDataset.EntitySetName := 'Grade_Descricoes';
    Grade_DescricoesDataset.Connection := DMConnection.ApiConnection;
    Grade_DescricoesDataset.Left := 72;
    Grade_DescricoesDataset.Top := 144;
    Grade_DescricoesDatasetid.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetid.Name := 'Grade_DescricoesDatasetid';
    Grade_DescricoesDatasetid.FieldName := 'id';
    Grade_DescricoesDatasetid.Required := True;
    Grade_DescricoesDatasetaliado_id.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetaliado_id.Name := 'Grade_DescricoesDatasetaliado_id';
    Grade_DescricoesDatasetaliado_id.FieldName := 'aliado_id';
    Grade_DescricoesDatasetaliado_id.Required := True;
    Grade_DescricoesDatasetdata_base_id.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetdata_base_id.Name := 'Grade_DescricoesDatasetdata_base_id';
    Grade_DescricoesDatasetdata_base_id.FieldName := 'data_base_id';
    Grade_DescricoesDatasetdata_base_id.Required := True;
    Grade_DescricoesDatasetnome.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetnome.Name := 'Grade_DescricoesDatasetnome';
    Grade_DescricoesDatasetnome.FieldName := 'nome';
    Grade_DescricoesDatasetnome.Required := True;
    Grade_DescricoesDatasetnome.Size := 255;
    Grade_DescricoesDatasettipo.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasettipo.Name := 'Grade_DescricoesDatasettipo';
    Grade_DescricoesDatasettipo.FieldName := 'tipo';
    Grade_DescricoesDatasetcodigo_interno.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetcodigo_interno.Name := 'Grade_DescricoesDatasetcodigo_interno';
    Grade_DescricoesDatasetcodigo_interno.FieldName := 'codigo_interno';
    Grade_DescricoesDatasetcodigo_interno.Required := True;
    Grade_DescricoesDatasetexcluido.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetexcluido.Name := 'Grade_DescricoesDatasetexcluido';
    Grade_DescricoesDatasetexcluido.FieldName := 'excluido';
    Grade_DescricoesDatasetinclusao.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetinclusao.Name := 'Grade_DescricoesDatasetinclusao';
    Grade_DescricoesDatasetinclusao.FieldName := 'inclusao';
    Grade_DescricoesDatasetalteracao.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetalteracao.Name := 'Grade_DescricoesDatasetalteracao';
    Grade_DescricoesDatasetalteracao.FieldName := 'alteracao';
    Grade_DescricoesDatasetexclusao.SetParentComponent(Grade_DescricoesDataset);
    Grade_DescricoesDatasetexclusao.Name := 'Grade_DescricoesDatasetexclusao';
    Grade_DescricoesDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Grade_DescricoesDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Grade_DescricoesDataset.AfterLoadDFMValues;
    Grade_DescricoesDatasetid.AfterLoadDFMValues;
    Grade_DescricoesDatasetaliado_id.AfterLoadDFMValues;
    Grade_DescricoesDatasetdata_base_id.AfterLoadDFMValues;
    Grade_DescricoesDatasetnome.AfterLoadDFMValues;
    Grade_DescricoesDatasettipo.AfterLoadDFMValues;
    Grade_DescricoesDatasetcodigo_interno.AfterLoadDFMValues;
    Grade_DescricoesDatasetexcluido.AfterLoadDFMValues;
    Grade_DescricoesDatasetinclusao.AfterLoadDFMValues;
    Grade_DescricoesDatasetalteracao.AfterLoadDFMValues;
    Grade_DescricoesDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
